export const createStyles = (theme?: any) => {
  const isDark = theme?.palette?.mode === 'dark';
  const primary = theme?.palette?.primary?.main ?? '#5B35A5';
  const titleColor = isDark ? '#FFFFFF' : '#000000DE !important';
  const iconBackground = isDark ? '#D0BCFA' : primary;
  const iconColor = isDark ? '#121212' : '#FFFFFF';
  const borderColor = isDark ? '#F8F7F929' : '#231F2929';
  const tooltipColor = isDark ? '#D7D2DF' : '#5D536C';
  const tooltipTextColor = isDark ? '#230254' : '#FFFFFF';

  return {
    sidebarWrapper: {
      height: '100%',
      display: 'flex',
      flexDirection: 'column',
      overflow: 'hidden',
      fontFamily: theme.typography.fontFamily,
    },
    buttonWrapper: {
      px: { xs: '16px', md: '12px' },
      pt: { xs: '16px', md: '12px' },
      'margin-left': '-8px',
    },
    backButton: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
    },
    sidebarContent: {
      flex: 1,
      display: 'flex',
      flexDirection: 'column',
      minHeight: 0,
      px: { xs: '12px', md: '12px' },
    },
    listWrapper: {
      flex: 1,
      minHeight: 0,
      overflowY: 'auto',
    },
    headerWrapper: {
      display: 'flex',
      alignItems: 'center',
      flexDirection: 'row',
      gap: '11px',
      minWidth: 0,
      my: '16px',
    },
    headerIcon: {
      width: '40px',
      height: '40px',
      borderRadius: '50%',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      backgroundColor: iconBackground,
      flexShrink: 0,
      color: iconColor,
    },
    title: {
      fontFamily: theme?.typography?.fontFamily,
      fontWeight: 600,
      fontStyle: 'normal',
      fontSize: '1.25rem',
      lineHeight: '160%',
      letterSpacing: '0px',
      flexShrink: 1,
      minWidth: 0,
      whiteSpace: 'nowrap',
      overflow: 'hidden',
      textOverflow: 'ellipsis',
      color: titleColor,
    },
    createButton: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      gap: '8px',
      height: '42px',
      width: '100%',
    },
    assignmentToolsWrapper: {
      p: '0.5rem',
      border: `1px solid ${borderColor}`,
      mt: '1rem',
      borderRadius: '0.5rem',
    },
    common: {
      display: 'flex',
      flexDirection: 'row',
      alignItems: 'center',
    },
    avatarStyle: {
      height: '32px',
      width: '32px',
      cursor: 'default',
    },
    newTabIcon: {
      height: '20px',
      width: '20px',
    },
    toolTitle: {
      fontFamily: theme?.typography?.fontFamily,
      fontWeight: 500,
      fontSize: '0.875rem',
    },
    tooltipStyles: {
      arrow: {
        sx: {
          left: '45% !important',
          transform: 'translateX(-50%) !important',
          color: tooltipColor,
        },
      },
      tooltip: {
        sx: {
          marginLeft: '25px',
          maxWidth: '230px',
          backgroundColor: tooltipColor,
          color: tooltipTextColor,
        },
      },
    },
    modalContainer: {
      display: 'flex',
      flexDirection: 'column',
      overflowX: 'hidden',
    },
    modalHeader: {
      p: 0,
      pb: 1,
      mr: -1,
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-between',
      flexShrink: 0,
    },
    modalContent: {
      p: 0,
      my: 1,
    },
    modalCardTitle: {
      color: theme.palette.primary.main,
      fontSize: '1rem',
      fontWeight: 'bold',
    },
    modalCardDescription: {
      color: theme.palette.text.secondary,
      fontSize: '.875rem',
      lineHeight: '180%',
      pt: 1,
      pb: 2,
    },
    modalFooter: {
      p: 0,
      display: 'flex',
      justifyContent: 'end',
      '& button': {
        px: 3,
        py: 1,
        textTransform: 'initial',
      },
    },
  };
};
